import React, { FunctionComponent } from 'react'

const StatusBarFailedIcon: FunctionComponent = () => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2305_37857)">
        <path
          d="M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z"
          fill="#F1B5B5"
        />
        <path
          d="M29.5 53C42.4787 53 53 42.4787 53 29.5C53 16.5213 42.4787 6 29.5 6C16.5213 6 6 16.5213 6 29.5C6 42.4787 16.5213 53 29.5 53Z"
          fill="#E47373"
        />
        <path
          d="M29.5 50C40.8218 50 50 40.8218 50 29.5C50 18.1782 40.8218 9 29.5 9C18.1782 9 9 18.1782 9 29.5C9 40.8218 18.1782 50 29.5 50Z"
          fill="#C85151"
        />
        <path
          d="M40.2143 34.8168C41.1708 35.7733 41.1708 37.413 40.2143 38.3696L38.3012 40.2826C37.3447 41.2391 35.705 41.2391 34.7484 40.2826L19.7174 25.2516C18.7609 24.295 18.7609 22.6553 19.7174 21.6988L21.6988 19.7174C22.6553 18.7609 24.295 18.7609 25.2516 19.7174L40.2143 34.8168Z"
          fill="white"
        />
        <path
          d="M34.7484 19.7848C35.705 18.8283 37.3447 18.8283 38.3012 19.7848L40.2826 21.7661C41.2391 22.7227 41.2391 24.3624 40.2826 25.3189L25.1832 40.2817C24.2267 41.2382 22.587 41.2382 21.6304 40.2817L19.7174 38.3686C18.7609 37.4121 18.7609 35.7724 19.7174 34.8158L34.7484 19.7848Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2305_37857">
          <rect width="59" height="59" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StatusBarFailedIcon
